import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuildConfigsComponent } from './build-configs/build-configs.component';
import { BuildConfigComponent } from './build-configs/build-config.component';
import { DashboardsComponent } from './gitlab/dashboard/dashboards.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'gitlab/dashboard'
  },
  {
    path: 'build-configs',
    pathMatch: 'full',
    component: BuildConfigsComponent
  },
  {
    path: 'build-configs/:id',
    pathMatch: 'full',
    component: BuildConfigComponent
  },
  {
    path: 'gitlab/dashboard',
    pathMatch: 'full',
    component: DashboardsComponent
  },
  {
    path: '**',
    component: BuildConfigsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
